import { useMutation } from '@tanstack/react-query';

import flexControlsClient, {
    CustomerFlexControlsPayload,
} from '@clients/domains/flexControls/flexControlsClient';
import notifyAPIError from '@utils/notifyAPIError';

const { postCreateCustomerFlexControl } = flexControlsClient();

const usePostCreateAccountFlexControl = (
    customerId: number,
    accountId: number,
    onSuccess?: () => void,
    onError?: () => void,
) => {
    const { data, error, isError, isLoading, isSuccess, mutate } = useMutation(
        ['postCreateCustomerFlexControl', customerId],
        (dataToSubmit: CustomerFlexControlsPayload) =>
            postCreateCustomerFlexControl({
                customerId,
                accountId: +accountId,
                dataToSubmit,
            }),
        {
            onSuccess: onSuccess,
            onError: (error) => {
                notifyAPIError(error);
                onError();
            },
        },
    );

    return { data, error, isError, isLoading, isSuccess, mutate };
};

export default usePostCreateAccountFlexControl;
